<div *ngIf="loading" class="loading-text">
  <p>{{ 'PleaseWaitDataLoading' | translate }}</p>
</div>

<div *ngIf="!loading && !choosedWave">
  <app-sub-header [pageTitle]="'Waves' | translate"></app-sub-header>
  <div class="padded-container">
    <dx-button text="{{ 'Wave1' | translate }}" type="default" class="full-width-button" (onClick)="chooseWave(1)"></dx-button>
    <dx-button text="{{ 'Wave2' | translate }}" type="default" class="full-width-button" (onClick)="chooseWave(2)"></dx-button>
    <dx-button text="{{ 'Wave3' | translate }}" type="default" class="full-width-button" (onClick)="chooseWave(3)"></dx-button>
    <dx-button text="{{ 'Wave4' | translate }}" type="default" class="full-width-button" (onClick)="chooseWave(4)"></dx-button>
    <dx-button text="{{ 'Wave5' | translate }}" type="default" class="full-width-button" (onClick)="chooseWave(5)"></dx-button>
    <dx-button text="{{ 'Back' | translate }}" type="danger" class="full-width-button" (onClick)="backToVoucher()"></dx-button>
  </div>
</div>

<div *ngIf="!loading && choosedWave">
  <app-sub-header [pageTitle]="pageTitle"></app-sub-header>
  <div class="padded-container">
    <dx-form [formData]="{ inputWaveCount, inputWaveText }" (onFieldDataChanged)="onFieldDataChanged($event)">
      <dxi-item dataField="inputWaveCount" [label]="{ text: 'Count' | translate }" editorType="dxNumberBox"></dxi-item>
      <dxi-item dataField="inputWaveText" [label]="{ text: 'Comment' | translate }" editorType="dxTextArea"></dxi-item>
    </dx-form>
    <dx-button text="{{ 'Save' | translate }}" type="success" class="full-width-button" (onClick)="saveWave()"></dx-button>
    <dx-button text="{{ 'Back' | translate }}" type="danger" class="full-width-button" (onClick)="backToWaves()"></dx-button>
  </div>
</div>